import { render, staticRenderFns } from "./suggestionsLists.vue.html?vue&type=template&id=78ed915a&"
import script from "./suggestionsLists.ts?vue&type=script&lang=ts&"
export * from "./suggestionsLists.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports